import $ from 'jquery';
import React from 'react';
import { render } from 'react-dom';
import bootstrapSite from '../app/bootstrapSite';
import { getCurrentBreakpoint } from '../utilities/device';
import { breakpoints } from '../common/constants/breakpoints';
import ContributeGiftList from '../components/ContributeGiftList/containers/ContributeGiftList';

bootstrapSite();

window.addEventListener('load', () => {
    const contributePage = document.querySelector('#bootstrap-giftListForm');

    if (contributePage) {
        const getHeaderMessage = contributePage.getAttribute('header-message');
        const ctaThankYouLink = contributePage.getAttribute('data-ctaLink');
        const optInMessage = contributePage.getAttribute('data-optIn');

        render(
            <ContributeGiftList
                headerMessage={getHeaderMessage}
                ctaThankYouLink={ctaThankYouLink}
                optInMessage={optInMessage}
            />, contributePage
        );
    }

    $('#gift-list-menu').on('click', function () {
        const currentBreakpoint = getCurrentBreakpoint();
        if (currentBreakpoint === breakpoints.xSmall || currentBreakpoint === breakpoints.small) {
            $(this).toggleClass('open');
        }
    });
});
